export default "__VITE_ASSET__BLFc0nxf__"